module.exports = __webpack_public_path__ + "img/dsci0057.90d832b7.jpg";